import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6e02837e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DlpLoader: require('/opt/render/project/src/channels2022/src/components/dlp/DlpLoader.vue').default,CategoryPageLoader: require('/opt/render/project/src/channels2022/src/components/category/CategoryPageLoader.vue').default})
